import { Grid } from "@mui/material";
import VirtualBatteryPercentageCard from "../../../VirtualBatteryPercentageCard";
import { useTranslation } from "react-i18next";
import {FC} from "react";
import { BatteryDistribution } from "@/components/VirtualBattery/types/percentages";

interface BatteryDistributionCardParams {
  batteryDistribution: BatteryDistribution
}

export const BatteryDistributionCard: FC<BatteryDistributionCardParams> = ({ batteryDistribution}) => {
  const { t } = useTranslation()
  const renderCards = batteryDistribution["distribution"]?.map((distribution, i) => {
    let lockedMessage = "";
    if (!distribution["isBateriaVirtualActive"]) {
      lockedMessage = t('common:text.solar_wallet.not_actived_because_of_dates');
    } else if (distribution["locked"]) {
      lockedMessage = t('common:text.solar_wallet.move.locked_help');
    }

    return (
      <Grid item key={`${distribution["contractName"]}__${i}`}>
        <VirtualBatteryPercentageCard
          key={`${distribution["contractName"]}__${i}`}
          style={{
            flex: 1,
            width: "100%",
          }}
          active={!!distribution.current}
          locked={!distribution["current"] && (!(distribution["isBateriaVirtualActive"]) || !!distribution["locked"])}
          lockedMessage={lockedMessage}
          percentageData={{
            polissaName: distribution["contractName"],
            percentage: distribution["pesPercentage"],
          }}
        />
      </Grid>
    );
  });


  return (
    <Grid container>
      {renderCards}
    </Grid>
  )
}

export default BatteryDistributionCard;
